import {Component} from '@angular/core';

@Component({
  selector: 'form-header',
  template: `<div class="form-group text-primary"><h6 class=""><ng-content></ng-content></h6></div>`
})
export class FormHeaderCmp {

}